export default {
    STAFF: 0,
    VISITOR: 1,
    OTHERAPP: 2,
    ROBOT: 3,
};
